import { render, staticRenderFns } from "./MemberTable.vue?vue&type=template&id=407c5d49&scoped=true"
import script from "./MemberTable.vue?vue&type=script&lang=js"
export * from "./MemberTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407c5d49",
  null
  
)

export default component.exports